import { useMemo } from 'react';

export const useUrlParams = () => {
    return useMemo(() => {
        const params = new URLSearchParams(window.location.search);

        return {
            transactionId: params.get('code') || params.get('codeTransaction'),
            urlServiceLiveness: params.get('urlServiceLiveness'),
            clientId: params.get('projectName') || 'default',
            platform: params.get('platform') || 'web',
            isMovil: params.get('isMovil') === 'true',
            emitReadyCam: params.get('emitReadyCam') || 'false',
            lang: params.get('lang') || 'es',
            action: params.get('action') || 'video_selfie_blank',
            debug: params.get('debug') === 'true',
            processId: params.get('processId'),
        };
    }, []);
};
